import React from "react";
import { ReactComponent as CalendarIcon } from "assets/icons/date_calendar.svg";
import moment from "moment";
import useAuth from "hooks/useAuth";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { ReactComponent as InfoIcon } from "assets/icons/info_2.svg";
import { priceChangeMockData } from "mocks/data";
import useSubscription from "hooks/useSubscription";

const ListOfChanges = ({ property, mainStyle }) => {
  const { user } = useAuth();
  const { subscriptionStatus } = useSubscription();
  const isPremium = subscriptionStatus.hasPremium;

  const filteredHistory =
    user && isPremium
      ? property?.history.filter((item) => item.sale_price > 0)
      : priceChangeMockData(); // Use mock data if user is not logged in

  return (
    <div
      style={mainStyle}
      className="scroll-container w-full h-[215px] rounded-[9px] mt-[9px] border-[1px] border-[#F0EFFB] flex items-start justify-between"
    >
      <div className="pl-[11px] flex flex-col  pr-[13px] flex-1 mt-[5px] h-full">
        <div className="flex items-center justify-between">
          <h2 className="text-[12px] bg-white z-[1] font-bold leading-[30px] text-black">
            Lista Modifiche
          </h2>
          {(!user || !isPremium) && (
            <>
              <span
                className="cursor-pointer"
                data-tooltip-id="list_of_changes_tooltip"
                data-tooltip-content="Monitoriamo variazioni di prezzo, aggiornamenti e movimenti di vendita. Con l'iscrizione gratuita potrai visualizzare queste informazioni"
              >
                <InfoIcon width={15} height={15} />
              </span>
              {/* Info Tooltip  */}
              <ReactTooltip
                id="list_of_changes_tooltip"
                place="top"
                positionStrategy="fixed"
                className="!max-w-64 !z-10 !text-sm !text-gray-500 !bg-white border !border-gray-200 !rounded-lg !shadow-xs"
              />
            </>
          )}
        </div>
        {filteredHistory?.length > 0 ? (
          <div className="mt-[3px] flex flex-col space-y-[6px] pb-3">
            {filteredHistory.map(({ changed_at }, index) => (
              <div
                key={index}
                className={`${
                  (!user || !isPremium) && index !== 0 ? "blur-[12px]" : ""
                } bg-[#F3F3F3A6]  cursor-pointer h-[49px] rounded-[10px] flex items-center justify-between px-[10.99px]`}
              >
                <div className="flex items-center space-x-[9.77px]">
                  <CalendarIcon />
                  <p className="text-[12px] font-semibold text-[#373C47] leading-[1.2px]">
                    {moment(changed_at).format("DD/MM/YYYY")}
                  </p>
                </div>
                <p className="text-[12px] font-normal text-[#373C47] opacity-60 leading-[1.2] mr-[18px]">
                  Variazione di Prezzo
                </p>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex-1 h-full flex flex-col justify-center">
            <div className="bg-[#F3F3F3A6] cursor-pointer h-[49px] rounded-[10px] flex items-center justify-between px-[10.99px]">
              <p className="text-[12px] font-normal text-[#373C47] opacity-60 leading-[1.2]">
                Nessuna Modifica Registrata
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ListOfChanges;
